import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { GIFT_CONFIG_QUERY } from "../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match }) => {
  const { data, loading } = useQuery(GIFT_CONFIG_QUERY, {
    variables: { id: match.params.config },
  });

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && data && data.AdminGiftConfig) {
    const {
      AdminGiftConfig: { id, productType, name },
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        id={id}
        productType={productType}
        name={name}
      ></Presenter>
    );
  }
});
